import { BulkCreateMenuEntryPayload } from "src/data/admin/types/menu";

const parseBool = (val: string): boolean => val.trim().toLowerCase() === "true" || val.trim() === "1";

const splitCsvRow = (row: string): string[] => {
    const result: string[] = [];
    let current = "";
    let inQuotes = false;
    for (let i = 0; i < row.length; i++) {
        const ch = row[i];
        if (ch === '"') {
            inQuotes = !inQuotes;
        } else if (ch === "," && !inQuotes) {
            result.push(current.trim());
            current = "";
        } else {
            current += ch;
        }
    }
    result.push(current.trim());
    return result;
};

export type CsvParseResult =
    | { ok: true; entries: BulkCreateMenuEntryPayload[] }
    | { ok: false; error: string };

export const parseCsv = (raw: string): CsvParseResult => {
    const lines = raw.split(/\r?\n/).filter((l) => l.trim().length > 0);
    if (lines.length < 2) return { ok: false, error: "CSV must have a header row and at least one data row." };

    const headers = splitCsvRow(lines[0]);
    const required: (keyof BulkCreateMenuEntryPayload)[] = [
        "section", "priority", "item", "price", "featured", "description",
    ];

    const missing = required.filter((f) => !headers.includes(f));
    if (missing.length > 0) return { ok: false, error: `Missing CSV columns: ${missing.join(", ")}` };

    const entries: BulkCreateMenuEntryPayload[] = [];

    for (let i = 1; i < lines.length; i++) {
        const cols = splitCsvRow(lines[i]);
        const row: Record<string, string> = {};
        headers.forEach((h, idx) => { row[h] = (cols[idx] ?? "").trim(); });

        entries.push({
            section: row.section,
            priority: parseInt(row.priority, 10),
            item: row.item,
            price: parseFloat(row.price),
            featured: parseBool(row.featured),
            description: row.description,
        });
    }

    return { ok: true, entries };
};
